import { useMutation, useQueryClient } from "@tanstack/react-query";
import { recordAttendance } from "../api/attendance";

export function useRecordAttendance() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: recordAttendance,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["tawa", "sessions", "open"] });
      void qc.invalidateQueries({
        predicate: (q) =>
          q.queryKey[0] === "tawa" &&
          q.queryKey[1] === "worker" &&
          q.queryKey[2] === "timeline",
      });
    },
  });
}
